import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { generateContext } from '@btime/react-contexts'
import React from 'react'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useDndState = () => React.useContext(StateContext)
export const useIsDraggingItem = reference => useDndState().draggingReference === reference
export const useIsDragging = () => !!useDndState().draggingType
export const useIsDraggingType = type => useDndState().draggingType === type

export const useDndActions = () => React.useContext(ActionsContext)

export const DndHandler = ({ disabled, ...props }) => {
  const [draggingReference, setDraggingReference] = React.useState()
  const [draggingType, setDraggingType] = React.useState(false)
  const state = { draggingType, draggingReference, disabled }
  const actions = { setDraggingType, setDraggingReference }
  return (
    <DndProvider
      backend={HTML5Backend}
      options={{
        scrollAngleRanges: [{ start: 30, end: 150 }]
      }}
    >
      <Provider state={state} actions={actions} {...props} />
    </DndProvider>
  )
}
